import React, {useEffect, useState} from 'react';
import classNames from "classnames";

import * as css from './css/checkbox.module.scss'

function Checkbox(props) {
    const {
        id, className,
        checked: initChecked,
        setChecked: propSetChecked = (value) => {
        }
    } = props;

    const [checked, setChecked] = useState(false);

    useEffect(() => {
        propSetChecked(checked)
    }, [checked])

    useEffect(() => {
        if (initChecked) {
            setChecked(true);
        }
    },[]);

    function onChange(e) {
        setChecked(!checked);
        // propSetChecked(!checked);
    }

    return (
        <div className={classNames(className,css.checkboxWrapper)}>
            <input type='checkbox' className={css.checkbox} id={id} checked={checked} onChange={onChange}/>
            <label className={classNames(css.label, {
                [css.active]: checked
            })} htmlFor={id}/>
        </div>
    );
}

export default Checkbox;
